import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

export interface IBlankIconProps extends IConDefaultType {}

function BlankIcon({ color, className, size = 24, rotate = 0, flip }: IBlankIconProps) {
  const fill = color || EColorMap.gray_0;

  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(3 3)">
          <path
            d="M6.5237 0.839382C6.5237 0.375804 6.8995 0 7.36308 0H10.6249C11.0885 0 11.4643 0.375804 11.4643 0.839382C11.4643 1.30296 11.0885 1.67876 10.6249 1.67876H7.36308C6.8995 1.67876 6.5237 1.30296 6.5237 0.839382Z"
            fill={fill}
          />
          <path
            d="M4.94023 0.826039C4.95427 1.2894 4.59003 1.67642 4.12666 1.69046C3.32757 1.71467 2.99468 1.77799 2.75756 1.89994L2.74907 1.9043C2.38919 2.08424 2.08979 2.3846 1.88667 2.77196C1.7655 3.00894 1.70252 3.34225 1.67839 4.13873C1.66434 4.6021 1.27733 4.96635 0.813965 4.95231C0.3506 4.93827 -0.0136487 4.55125 0.000392694 4.08789C0.0245014 3.2923 0.0819995 2.61038 0.39496 2.00185L0.397514 1.99688C0.749394 1.32372 1.29371 0.756177 1.99412 0.404804C2.60156 0.0937993 3.28212 0.0365173 4.07581 0.012466C4.53918 -0.00157531 4.92619 0.362674 4.94023 0.826039Z"
            fill={fill}
          />
          <path
            d="M13.0478 0.826039C13.0618 0.362674 13.4488 -0.00157531 13.9122 0.012466C14.7059 0.0365173 15.3864 0.093799 15.9939 0.404801C16.6943 0.756174 17.2386 1.32373 17.5905 1.99689L17.5931 2.00184C17.906 2.61038 17.9635 3.2923 17.9876 4.08789C18.0017 4.55125 17.6374 4.93827 17.174 4.95231C16.7107 4.96635 16.3237 4.6021 16.3096 4.13873C16.2855 3.34225 16.2225 3.00895 16.1013 2.77196C15.8982 2.38461 15.5989 2.0842 15.239 1.90425L15.2304 1.89999C14.9933 1.77803 14.6604 1.71467 13.8614 1.69046C13.398 1.67642 13.0337 1.2894 13.0478 0.826039Z"
            fill={fill}
          />
          <path
            d="M0.839389 6.52369C1.30297 6.52369 1.67877 6.8995 1.67877 7.36308V10.6249C1.67877 11.0885 1.30297 11.4643 0.839389 11.4643C0.375812 11.4643 7.56644e-06 11.0885 7.56644e-06 10.6249V7.36308C7.56644e-06 6.8995 0.375812 6.52369 0.839389 6.52369Z"
            fill={fill}
          />
          <path
            d="M17.1486 6.52369C17.6122 6.52369 17.988 6.8995 17.988 7.36308V10.6249C17.988 11.0885 17.6122 11.4643 17.1486 11.4643C16.685 11.4643 16.3092 11.0885 16.3092 10.6249V7.36308C16.3092 6.8995 16.685 6.52369 17.1486 6.52369Z"
            fill={fill}
          />
          <path
            d="M17.1861 13.0478C17.6495 13.0618 18.0137 13.4488 17.9997 13.9122C17.9756 14.7078 17.9181 15.3897 17.6051 15.9982L17.6026 16.0032C17.2507 16.6764 16.7063 17.244 16.0058 17.5954C15.3984 17.9063 14.7179 17.9636 13.9243 17.9876C13.4609 18.0017 13.0739 17.6374 13.0599 17.174C13.0458 16.7107 13.4101 16.3237 13.8734 16.3096C14.6725 16.2854 15.0054 16.2221 15.2425 16.1001L15.251 16.0958C15.6109 15.9158 15.9103 15.6155 16.1134 15.2281C16.2346 14.9911 16.2976 14.6578 16.3217 13.8613C16.3357 13.398 16.7228 13.0337 17.1861 13.0478Z"
            fill={fill}
          />
          <path
            d="M0.813965 13.0599C1.27733 13.0458 1.66434 13.4101 1.67839 13.8734C1.7026 14.6725 1.76591 15.0054 1.88786 15.2425L1.89223 15.251C2.07217 15.6109 2.37253 15.9103 2.75989 16.1134C2.99687 16.2346 3.33018 16.2976 4.12666 16.3217C4.59003 16.3357 4.95427 16.7228 4.94023 17.1861C4.92619 17.6495 4.53918 18.0137 4.07581 17.9997C3.28022 17.9756 2.59831 17.9181 1.98978 17.6051L1.98482 17.6026C1.31165 17.2507 0.7441 16.7064 0.392727 16.006C0.0817256 15.3985 0.024444 14.718 0.000392694 13.9243C-0.0136487 13.4609 0.3506 13.0739 0.813965 13.0599Z"
            fill={fill}
          />
          <path
            d="M6.5237 17.1486C6.5237 16.685 6.8995 16.3092 7.36308 16.3092H10.6249C11.0885 16.3092 11.4643 16.685 11.4643 17.1486C11.4643 17.6122 11.0885 17.988 10.6249 17.988H7.36308C6.8995 17.988 6.5237 17.6122 6.5237 17.1486Z"
            fill={fill}
          />
        </g>
      </svg>
    </i>
  );
}

export default BlankIcon;
